import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

export const FirstSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  return (
    <section className="py-5">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8}>
            <div
              className="overflow-hidden rounded-3 shadow-sm"
              style={{ border: "1px solid #fff" }}
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src="../media/hero.jpg"
                alt="AI dashboard interface for Nexum app"
                className="img-fluid w-100"
                style={{
                  objectFit: "cover",
                  objectPosition: "center top",
                  maxHeight: "500px",
                }}
                data-aos="zoom-in"
                data-aos-delay="350"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
